import { StickyBar } from '@bob/library'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapTopbarAlerts } from '@websrc/DataMappers/mapTopbar'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'
import React, { useEffect, useState } from 'react'

import * as SC from './TopbarAlerts.style'

export interface TopbarAlertsProps {
  alerts: ReturnType<typeof mapTopbarAlerts>
  isSticky?: boolean
}

export const TopbarAlerts = ({ alerts, isSticky = false }: TopbarAlertsProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (!alerts?.length) {
        return
      }

      let nextIndex = activeIndex + 1

      if (nextIndex >= alerts.length) {
        nextIndex = 0
      }

      setActiveIndex(nextIndex)
    }, 5000)

    return () => clearTimeout(timerId)
  }, [alerts, activeIndex])

  if (!alerts?.length) {
    return null
  }

  const bar = (
    <SC.Wrapper aria-hidden={'true'} data-testid={'alerts-bar'}>
      {alerts.map((alert, i) => {
        let top = '5px'

        if (i < activeIndex) {
          top = '-100%'
        } else if (i > activeIndex) {
          top = '100%'
        }

        return (
          <SC.CTAWrapper data-top={top} key={i}>
            <SC.CTA
              as={SpotLinkAnchor}
              data-testid={'alert-cta'}
              link={alert}
              noStyles={true}
              onClick={() => {
                matomo.trackEvent('engagement', 'all', ['alert bar'], [alert.cta_text], 'link')
              }}
              tabIndex={-1}
            >
              {alert.cta_text}
            </SC.CTA>
          </SC.CTAWrapper>
        )
      })}
    </SC.Wrapper>
  )

  if (isSticky) {
    return (
      <StickyBar bgColor={'corporateYellow'} noContainer={true}>
        {bar}
      </StickyBar>
    )
  }

  return bar
}
